import $ from 'jquery';

$( function() {
  if( $( '.error' ).length ) {
    var MAX_HORIZONTAL_SLICE_HEIGHT = 5;
    var MAX_VERTICAL_SLICE_WIDTH = 12;
    var HORIZONTAL_AMPLITUDE = 800;
    var VERTICAL_AMPLITUDE = 1000;
    
    var container, cnt_inner, btn, total_H, total_W, reached_H, reached_W;
    
    
    function glitch() {
    
      // basic reset
      container.innerHTML = cnt_inner;
      reached_H = 0;
      reached_W = 0;
    
      // setting horizontal slices
      while (reached_H < total_H) {
    
        //create multiple divs
        var clone = document.createElement('div');
        clone.className = "clone horizontal";
        clone.innerHTML = "<div class = 'clone_offsetter'>" + cnt_inner + "</div>";
    
        var cloned = clone.getElementsByTagName( 'input' )[0];
        
        // avoid elements with the smae id
        cloned.id = ""; 
    
        var offsetter = clone.getElementsByClassName( 'clone_offsetter' )[0];
    
        container.appendChild( clone );
    
        var slice_H = Math.ceil( MAX_HORIZONTAL_SLICE_HEIGHT * Math.random() );
        var slice_ML = Math.ceil( HORIZONTAL_AMPLITUDE * Math.random() );
    
        if ( Math.random() > 0.45 ) {
          slice_ML = slice_ML * -1;
        }
    
        clone.style.marginTop = reached_H + "px";
        offsetter.style.marginTop = "-" + reached_H + "px";
        clone.style.height = slice_H + "px";
    
        // Storing the value first instead of immediately setting the marginLeft allows the clone's CSS transition properties to be taken into account
        clone.glitch_ML = slice_ML + "px";
        
        reached_H += slice_H;
      }
    
      // repeat for the vertical slices
      while ( reached_W < total_W ) {
    
        var clone = document.createElement( 'div' );
        clone.className = "clone vertical";
        clone.innerHTML = "<div class = 'clone_offsetter'>" + cnt_inner + "</div>";
    
        var cloned = clone.getElementsByTagName( 'input' )[0];
        cloned.id = "";
    
        var offsetter = clone.getElementsByClassName( 'clone_offsetter' )[0];
    
        container.appendChild(clone);
    
        var slice_W = Math.ceil (MAX_VERTICAL_SLICE_WIDTH * Math.random() );
        var slice_MT = Math.ceil( VERTICAL_AMPLITUDE * Math.random() );
    
        if ( Math.random() > 0.45 ) {
          slice_MT = slice_MT * -1;
        }
    
        clone.style.marginLeft = reached_W + "px";
        offsetter.style.marginLeft = "-" + reached_W + "px";
        clone.style.width = slice_W + "px";
    
        clone.glitch_MT = slice_MT + "px";
    
        reached_W += slice_W;
      }
    
      // set margins
      var all_H_clones = container.getElementsByClassName( 'clone horizontal' );
      var all_V_clones = container.getElementsByClassName( 'clone vertical' );
    
      // A few millisecs of delay between appendChild() and this phase are enough to give the elements a 0px 0px margin first, from which the CSS transition can be started
      setTimeout( function () {
        for ( var i = 0; i < all_H_clones.length; i++ ) {
          all_H_clones[i].style.marginLeft = all_H_clones[i].glitch_ML;
        }
        for ( var i = 0; i < all_V_clones.length; i++ ) {
          all_V_clones[i].style.marginTop = all_V_clones[i].glitch_MT;
        }
      }, 50);
        
        //second timeout to give a broken effect before redirecting to the homepage
        setTimeout( () => {
          window.location.href = "/";
        }, "2000")
    }
    
    container = document.getElementById( 'error-container' );
    cnt_inner = container.innerHTML;
    total_H = container.offsetHeight;
    total_W = container.offsetWidth;
    btn = document.getElementById( 'the_button' );
    btn.addEventListener( 'click', glitch );
    if ( MAX_HORIZONTAL_SLICE_HEIGHT > total_H ) {
      MAX_HORIZONTAL_SLICE_HEIGHT = total_H;
    }

    if ( MAX_VERTICAL_SLICE_WIDTH > total_W ) {
      MAX_VERTICAL_SLICE_WIDTH = total_W;
    }
  }
})